// import React, { useState } from "react";
// import {
//   AppShell,
//   Header,
//   Navbar,
//   ActionIcon,
//   ScrollArea,
// } from "@mantine/core";
// import {
//   Home,
//   Paperclip,
//   Bell,
//   Template,
//   LayoutSidebarLeftCollapse,
//   LayoutSidebarRightCollapse,
//   Snowman,
//   ReportMoney,
//   Plus,
//   LetterCase,
//   Mailbox,
// } from "tabler-icons-react";
// import { LinksGroup } from "../../components/NavbarLinkGroup";
// import AppHeader from "../../components/Header/AppHeader";
// import { useSelector } from "react-redux";
// import { selectUserData } from "../../redux/selectors";
// import { set } from "date-fns";

// const MainApp = ({ appContent }) => {
//   const currentUser = useSelector(selectUserData) || {};
//   const { name } = currentUser.loginAs;

//   const mockdata = [
//     {
//       label: "dashboard",
//       icon: Home,
//       link: "/app",
//     },
//     {
//       label: "notifications",
//       icon: Bell,
//       link: "/app/notifications",
//     },
//     {
//       label: "recovery locker",
//       icon: Paperclip,
//       link: "/app/recovery/locker",
//     },
//     // {
//     //   label: 'case',
//     //   icon: LetterCase,
//     //   link: '/app/dispute-manager/cases'
//     // },
//     // {
//     //   label: 'budget manager',
//     //   icon: ReportMoney,
//     //   link: '/app/budget-manager',
//     // },
//     // {
//     //   label: 'gmail inbox',
//     //   icon: Mailbox,
//     //   link: '/app/gmail-inbox',
//     // },
//     // {
//     //   label: 'Documents',
//     //   icon: Mailbox,
//     //   link: '/app/documents',
//     // }
//   ];

//   if (["Initiator", "Editor"].includes(name)) {
//     mockdata.splice(2, 0, {
//       label: "my recovery",
//       icon: Paperclip,
//       link: "/app/recovery",
//     });
//   }
//   if (["Initiator", "Editor"].includes(name)) {
//     mockdata.splice(3, 0, {
//       label: "new recovery",
//       icon: Plus,
//       link: "/app/recovery/new",
//     });
//   }
//   if (name === "Editor") {
//     mockdata.splice(4, 0, {
//       label: "templates",
//       icon: Template,
//       initiallyOpened: true,
//       links: [
//         { label: "notice", link: "/app/template/notice" },
//         { label: "email", link: "/app/template/email" },
//       ],
//     });
//   } else if (name === "Initiator") {
//     mockdata.splice(4, 0, {
//       label: "templates",
//       icon: Template,
//       initiallyOpened: true,
//       links: [{ label: "email", link: "/app/template/email" }],
//     });
//   }
//   // if (name === 'system-admin') {
//   //   mockdata.splice(3, 0, {
//   //     label: 'team manager',
//   //     icon: Snowman,
//   //     link: '/app/service-providers',
//   //   });
//   // }

//   const links = mockdata.map((item) => (
//     <LinksGroup {...item} key={item.label} />
//   ));

//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

//   return (
//     <AppShell
//       padding="md"
//       navbar={
//         <Navbar
//           style={{ backgroundColor: "#F1F4FA" }}
//           width={{ base: sidebarCollapsed ? 50 : 300 }}
//           height="calc(100vh - 65px)"
//           p="xs"
//         >
//           <Navbar.Section grow component={ScrollArea}>
//             <div className="flex flex-col">
//               <div className="flex justify-end">
//                 <ActionIcon
//                   color="blue"
//                   onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
//                 >
//                   {sidebarCollapsed ? (
//                     <LayoutSidebarRightCollapse />
//                   ) : (
//                     <LayoutSidebarLeftCollapse />
//                   )}
//                 </ActionIcon>
//               </div>
//               {!sidebarCollapsed && <div>{links}</div>}
//             </div>
//           </Navbar.Section>
//         </Navbar>
//       }
//       header={
//         <Header height={65}>
//           <AppHeader />
//         </Header>
//       }
//     >
//       <div
//         style={{ backgroundColor: "#FFFFFF", minHeight: "calc(100vh - 100px)" }}
//       >
//         {appContent}
//       </div>
//     </AppShell>
//   );
// };

// export default MainApp;


import React, { useState } from "react";
import {
  AppShell,
  Header,
  Navbar,
  ActionIcon,
  ScrollArea,
} from "@mantine/core";
import {
  Home,
  Paperclip,
  Bell,
  Template,
  LayoutSidebarLeftCollapse,
  LayoutSidebarRightCollapse,
  Plus,
} from "tabler-icons-react";
import { LinksGroup } from "../../components/NavbarLinkGroup";
import AppHeader from "../../components/Header/AppHeader";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";
import "./sidebar.css"; // Ensure this is imported for sidebar-heading styling
import {MyBagIcon, DocLockerIcon, NotificationIcon, PlusIcon, TemplatesIcon, HomeIcon, SIgnedDocIcon } from "../../icons/new-icons/icon";


const MainApp = ({ appContent }) => {
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser.loginAs || {};
  const { name } = loginAs;

  // 1. Core mockdata initialization (Preserving your exact logic structure)
  const mockdata = [
    {
      label: "Overview",
      icon: MyBagIcon,
      link: "/app",
    },
    {
      label: "Alerts",
      icon: NotificationIcon,
      link: "/app/notifications",
    },
    {
      label: "Receivable locker",
      icon: DocLockerIcon,
      link: "/app/recovery/locker",
    },
  ];

  // 2. Preserved Splice Logic (No changes to business rules)
  if (["Initiator", "Editor"].includes(name)) {
    mockdata.splice(2, 0, {
      label: "Receivables",
      icon: SIgnedDocIcon,
      link: "/app/recovery",
    });
  }
  if (["Initiator", "Editor"].includes(name)) {
    mockdata.splice(3, 0, {
      label: "New",
      icon: PlusIcon,
      link: "/app/recovery/new",
    });
  }
  if (name === "Editor") {
    mockdata.splice(4, 0, {
      label: "Templates",
      icon: TemplatesIcon,
      initiallyOpened: true,
      links: [
        { label: "Notice", link: "/app/template/notice" },
        { label: "Email", link: "/app/template/email" },
      ],
    });
  } else if (name === "Initiator") {
    mockdata.splice(4, 0, {
      label: "Templates",
      icon: TemplatesIcon,
      initiallyOpened: true,
      links: [{ label: "Email", link: "/app/template/email" }],
    });
  }

  // 3. UI Grouping Configuration (Adapting your exact items to the target UX)
  const menuKeys = [
    "Overview",
    "Alerts",
    "Receivables",
    "New",
  ];

  const menuItems = mockdata.filter((item) =>
    menuKeys.includes(item.label)
  );

  const otherItems = mockdata.filter(
    (item) => !menuKeys.includes(item.label)
  );

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <AppShell
      padding="md"
      navbar={
        <Navbar
          width={{ base: sidebarCollapsed ? 60 : 250 }}
          height="calc(100vh - 65px)"
          p={0}
          style={{ backgroundColor: "#EEF2F3" }}
        >
          <Navbar.Section grow component={ScrollArea}>
            <div className="flex flex-col">
              {/* Toggle ActionIcon styled to match the target UI */}
              <span className="flex justify-end pr-3 pt-2">
                <ActionIcon
                  onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                >
                  {sidebarCollapsed ? (
                    <LayoutSidebarRightCollapse color="#649fb1" />
                  ) : (
                    <LayoutSidebarLeftCollapse color="#649fb1" />
                  )}
                </ActionIcon>
              </span>

              {/* Sidebar Grouped Content Layout */}
              {!sidebarCollapsed && (
                <div className="pt-2" style={{ marginTop: "-45px" }}>
                  <div className="sidebar-heading">MENU</div>
                  {menuItems.map((item) => (
                    <LinksGroup {...item} key={item.label} />
                  ))}

                  {/* Hide "OTHERS" section for Approver & Reviewer roles */}
                  {!["Approver", "Reviewer"].includes(name) && otherItems.length > 0 && (
                    <>
                      <div className="sidebar-heading mt-4">OTHERS</div>
                      {otherItems.map((item) => (
                        <LinksGroup {...item} key={item.label} />
                      ))}
                    </>
                  )}
                </div>
              )}
            </div>
          </Navbar.Section>
        </Navbar>
      }
      header={
        <Header height={65}>
          <AppHeader />
        </Header>
      }
    >
      <div style={{ backgroundColor: "#fff", minHeight: "100%" }}>
        {appContent}
      </div>
    </AppShell>
  );
};

export default MainApp;
